<template>
  <transition name="fade">
    <div v-if="show" :class="classes">
      <span class="mr-3">{{ icon }}</span>
      <span>{{ message }}</span>
      <button v-if="dismissible" @click="show = false" class="ml-auto text-lg">✕</button>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'info',
    validator: (v) => ['success', 'error', 'warning', 'info'].includes(v)
  },
  message: String,
  dismissible: {
    type: Boolean,
    default: true
  },
  duration: Number
})

const show = ref(true)

const classes = computed(() => {
  const base = 'flex items-center p-4 rounded-lg font-semibold mb-4'
  const variants = {
    success: 'bg-green-100 text-green-800 border border-green-300',
    error: 'bg-red-100 text-red-800 border border-red-300',
    warning: 'bg-yellow-100 text-yellow-800 border border-yellow-300',
    info: 'bg-blue-100 text-blue-800 border border-blue-300'
  }
  return `${base} ${variants[props.type]}`
})

const icon = computed(() => {
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  }
  return icons[props.type]
})

if (props.duration) {
  setTimeout(() => {
    show.value = false
  }, props.duration)
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
